const toSafeString = (value) => {
	if (typeof value === "string") {
		return value;
	}

	try {
		return JSON.stringify(value);
	} catch {
		return "Unknown error";
	}
};

export const getErrorMessage = (error) => {
	if (Array.isArray(error?.errors) && error.errors.length > 0) {
		return error.errors
			.map((item) => {
				if (typeof item?.message === "string" && item.message.length > 0) {
					return item.message;
				}

				return toSafeString(item);
			})
			.filter(Boolean)
			.join(", ");
	}

	if (typeof error?.message === "string" && error.message.length > 0) {
		return error.message;
	}

	if (error?.message && typeof error.message === "object") {
		return toSafeString(error.message);
	}

	if (typeof error === "string" && error.length > 0) {
		return error;
	}

	return toSafeString(error);
};
